/**
 * @file Best-effort client error reporting to POST /log-error (failures swallowed).
 */

import client from './client';

/**
 * Send a client-side error to the backend for logging. Non-blocking; failures are ignored.
 * @param {{ message: string, componentStack?: string }} payload
 */
export const logClientError = (payload) => {
  const body = {
    message: payload.message || '',
    componentStack: payload.componentStack || '',
    url: typeof window !== 'undefined' ? window.location.href : '',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    timestamp: new Date().toISOString(),
  };
  // REVIEW [LOW]: Unauthenticated ingest endpoint; avoid putting secrets in message/stack.
  client.post('/log-error', body).catch(() => {
    // Ignore network errors; don't throw or show to user
  });
};
